import { render, staticRenderFns } from "./LoyaltyMovements.vue?vue&type=template&id=74e9b4d3&scoped=true&"
import script from "./LoyaltyMovements.vue?vue&type=script&lang=js&"
export * from "./LoyaltyMovements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e9b4d3",
  null
  
)

export default component.exports